module.exports = __webpack_public_path__ + "img/NI.288efeb1.png";